import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowConfigValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'object',
            empty: false,
            mandatory: false,
            attributes: {
                flex: {
                    type: 'boolean',
                    empty: false,
                    mandatory: false,
                },
                v_align: {
                    type: 'string',
                    empty: false,
                    mandatory: false,
                }
            }
        };
    }
}
